<template>
  <div class="app-container" id="taskList">
    <el-radio-group @change="handleClick" v-model="listQuery.type">
      <el-radio border label="0" size="small" class="myRadio">全部</el-radio>
      <el-radio border label="1" size="small" class="myRadio"
        >我已审核</el-radio
      >
      <el-radio border label="2" size="small" class="myRadio"
        >待我审核</el-radio
      >
      <el-radio border label="3" size="small" class="myRadio"
        >我已认领</el-radio
      >
      <el-radio border label="4" size="small" class="myRadio"
        >待我认领</el-radio
      >
      <el-radio border label="5" size="small" class="myRadio">我申请</el-radio>
    </el-radio-group>
    <span style="margin-top: 4px; margin-left: 20px; display: inline-block">
      <el-button
        type="primary"
        icon="el-icon-search"
        size="small"
        :class="show ? 'gray' : ''"
        @click="changeShow()"
        >搜索</el-button
      >
      <el-button
        type="primary"
        icon="el-icon-plus"
        size="small"
        @click="handleAdd"
        style="margin-left: 15px"
        >新增</el-button
      >
    </span>
    <!-- <el-tabs v-model="listQuery.type" @tab-click="handleClick">
      <el-tab-pane label="全部" name="0"></el-tab-pane>
      <el-tab-pane label="我已审核" name="1"></el-tab-pane>
      <el-tab-pane label="待我审核" name="2"></el-tab-pane>
      <el-tab-pane label="我已认领" name="3"></el-tab-pane>
      <el-tab-pane label="待我认领" name="4"></el-tab-pane>
      <el-tab-pane label="我申请" name="5"></el-tab-pane>
    </el-tabs>
       <span style="margin-top: 4px; display: inline-block">
        <el-button type="primary" icon="el-icon-search" size="small"
          >搜索</el-button
        >
        <el-button
          type="primary"
          icon="el-icon-plus"
          size="small"
          @click="handleAdd"
          style="margin-left: 15px"
          >新增</el-button
        >
    </span>-->
    <div class="mycontainer" style="margin-bottom: 10px">
      <el-form
        ref="queryForm"
        :model="listQuery"
        :inline="true"
        v-if="show"
        label-width="80px"
      >
        <el-form-item label="部门" prop="bmbh">
          <el-select
            ref="bmbh"
            v-model="listQuery.bmbh"
            placeholder="请选择所属部门"
            clearable
            filterable
            size="small"
            style="width: 200px"
            class="filter-item"
            @change="handleChangeTx"
          >
            <el-option
              v-for="item in bmList"
              :key="item.bmmc"
              :label="item.bmmc"
              :value="item.bmbh"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="所属条线" prop="txlx">
          <el-select
            ref="txlx"
            v-model="listQuery.txlx"
            placeholder="请选择所属条线"
            clearable
            filterable
            size="small"
            style="width: 200px"
            class="filter-item"
            @change="handleChangeLx"
          >
            <el-option
              v-for="item in ygtxoptions"
              :key="item.value"
              :label="item.value"
              :value="item.key"
            />
          </el-select>
        </el-form-item>

        <el-form-item label="任务类型" prop="name">
          <el-select
            ref="name"
            v-model="listQuery.name"
            placeholder="请选择任务类型"
            clearable
            filterable
            size="small"
            style="width: 200px"
            class="filter-item"
            @change="handleChangeZl"
          >
            <el-option
              v-for="item in lxList"
              :key="item.key"
              :label="item.value"
              :value="item.value"
            />
          </el-select>
        </el-form-item>

        <el-form-item label="子类" prop="sun">
          <el-select
            ref="sun"
            v-model="listQuery.sun"
            placeholder="请选择子类"
            clearable
            filterable
            size="small"
            style="width: 200px"
            class="filter-item"
          >
            <el-option
              v-for="item in zlList"
              :key="item.key"
              :label="item.value"
              :value="item.value"
            />
          </el-select>
        </el-form-item>

        <el-form-item label="任务状态" prop="status">
          <el-select
            ref="status"
            v-model="listQuery.status"
            placeholder="请输入任务状态"
            clearable
            filterable
            size="small"
            style="width: 200px"
            class="filter-item"
          >
            <el-option
              v-for="item in statusList"
              :key="item.dictValue"
              :label="item.dictLabel"
              :value="item.dictValue"
            />
          </el-select>
        </el-form-item>

        <el-form-item label="任务标题" prop="title">
          <el-input
            v-model="listQuery.title"
            placeholder="请输入任务标题"
            clearable
            size="small"
            style="width: 200px"
          />
        </el-form-item>

        <el-form-item label="认领人" prop="rlr">
          <treeselect
            v-model="listQuery.rlr"
            :multiple="true"
            placeholder="请选择认领人"
            :options="deptUser"
            :disable-branch-nodes="true"
            :show-count="true"
            value-consists-of="LEAF_PRIORITY"
            no-results-text="未搜到任何结果"
            :clear-on-select="true"
            :normalizer="normalizer"
            style="width: 270px; line-height: 18px; margin-top: 4px"
            :limit="1"
            :max-height="200"
          />
        </el-form-item>

        <!-- <el-form-item label="认领日期" prop="rlrq">
          <el-date-picker
            v-model="listQuery.rlrq"
            type="date"
            placeholder="选择认领日期"
            clearable
            size="small"
            style="width: 200px"
          ></el-date-picker>
        </el-form-item>-->

        <span style="margin-top: 4px; display: inline-block">
          <el-button
            type="primary"
            icon="el-icon-search"
            size="small"
            @click="getList"
            >查询</el-button
          >

          <el-button
            type="primary"
            icon="el-icon-download"
            size="small"
            @click="handleExport"
            style="margin-left: 15px"
            >导出</el-button
          >
          <el-button
            icon="el-icon-refresh"
            size="small"
            class="filter-item"
            style="margin-left: 15px"
            @click="reset"
            >重置</el-button
          >
        </span>
      </el-form>
    </div>
    <div>
      <el-table
        :max-height="height"
        v-loading="task.taskList.list.listLoading"
        :data="task.taskList.list.item"
        fit
        highlight-current-row
        :header-cell-style="tableHeaderColor"
        :default-sort="{ prop: 'date', order: 'descending' }"
        tooltip-effect="dark"
      >
        <el-table-column
          fixed
          label="操作"
          min-width="150"
          align="center"
          class-name="small-padding fixed-width"
        >
          <template slot-scope="scope">
            <el-dropdown size="small">
              <el-button type="primary" size="small">
                操作列
                <i class="el-icon-arrow-down el-icon--right"></i>
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item>
                  <div @click="handleView(scope.row.id, scope.row.txlx)">
                    <el-button type="text" size="small">查看</el-button>
                  </div>
                </el-dropdown-item>

                <el-dropdown-item
                  v-if="
                    (scope.row.control.isrwsqr || scope.row.control.isadmin) &&
                    (scope.row.status == 1 ||
                      scope.row.status == 3 ||
                      scope.row.status == 4 ||
                      scope.row.status == 5 ||
                      scope.row.status == 6 ||
                      scope.row.status == 7 ||
                      scope.row.status == 8)
                  "
                >
                  <div @click="rwzzUpdate(scope.row)">
                    <el-button type="text" size="small">终止</el-button>
                  </div>
                </el-dropdown-item>

                <el-dropdown-item
                  v-if="
                    (scope.row.control.isrwsqr || scope.row.control.isadmin) &&
                    scope.row.status != 9 &&
                    scope.row.status != 10
                  "
                >
                  <div @click="handleEdit(scope.row)">
                    <el-button type="text" size="small">编辑</el-button>
                  </div>
                </el-dropdown-item>

                <el-dropdown-item
                  v-if="
                    (scope.row.control.isrwshr || scope.row.control.isadmin) &&
                    scope.row.status == 1
                  "
                >
                  <div @click="handleRwAppylAudit(scope.row.id)">
                    <el-button type="text" size="small">任务审核</el-button>
                  </div>
                </el-dropdown-item>

                <el-dropdown-item
                  v-if="
                    (scope.row.control.isrldx || scope.row.control.isadmin) &&
                    scope.row.control.isrl != 1 &&
                    ((scope.row.txlx == 1 &&
                      scope.row.isbtg != 1 &&
                      (scope.row.status == 3 ||
                        scope.row.status == 5 ||
                        scope.row.status == 6)) ||
                      (scope.row.txlx != 1 &&
                        (scope.row.status == 3 ||
                          scope.row.status == 6 ||
                          scope.row.status == 7)))
                  "
                >
                  <div @click="handleRwrl(scope.row.id)">
                    <el-button type="text" size="small">任务认领</el-button>
                  </div>
                </el-dropdown-item>

                <el-dropdown-item
                  v-if="
                    (scope.row.control.isrlshr || scope.row.control.isadmin) &&
                    scope.row.control.isshrsz &&
                    scope.row.txlx == 1 &&
                    scope.row.status == 4
                  "
                >
                  <div @click="handleRlsh(scope.row.id)">
                    <el-button type="text" size="small">认领审核</el-button>
                  </div>
                </el-dropdown-item>

                <el-dropdown-item
                  v-if="
                    scope.row.control.isadmin &&
                    scope.row.control.isshrsz == 0 &&
                    scope.row.txlx == 1 &&
                    scope.row.status == 4
                  "
                >
                  <div @click="handleRlshsz(scope.row.id)">
                    <el-button type="text" size="small">认领审核设置</el-button>
                  </div>
                </el-dropdown-item>

                <el-dropdown-item
                  v-if="
                    (scope.row.control.isrwrlr ||
                      scope.row.control.isxzr ||
                      scope.row.control.isadmin) &&
                    (scope.row.status == 7 || scope.row.status == 8)
                  "
                >
                  <div
                    @click="
                      handleUpload(
                        scope.row.id,
                        scope.row.txlxString,
                        scope.row.rwbh,
                        scope.row.title
                      )
                    "
                  >
                    <el-button type="text" size="small">{{
                      scope.row.txlx == "1" ? "任务完成" : "成果物上传"
                    }}</el-button>
                  </div>
                </el-dropdown-item>

                <el-dropdown-item
                  v-if="
                    (scope.row.control.iscgwshr || scope.row.control.isadmin) &&
                    (scope.row.status == 7 || scope.row.status == 8)
                  "
                >
                  <div @click="toCgwList(scope.row.id)">
                    <el-button type="text" size="small">
                      {{
                        scope.row.txlx == "1" ? "任务完成确认" : "成果物审核"
                      }}
                    </el-button>
                  </div>
                </el-dropdown-item>

                <el-dropdown-item
                  v-if="
                    (scope.row.control.isrwsqr || scope.row.control.isadmin) &&
                    scope.row.control.isjfjl == 1 &&
                    (scope.row.status == 7 ||
                      scope.row.status == 8 ||
                      scope.row.status == 9)
                  "
                >
                  <div @click="reward(scope.row.id)">
                    <el-button type="text" size="small">积分奖励</el-button>
                  </div>
                </el-dropdown-item>
                <!-- 
                <el-dropdown-item>
                  <div>
                    <el-button type="text" size="small">上线确认</el-button>
                  </div>
                </el-dropdown-item>-->
              </el-dropdown-menu>
            </el-dropdown>
          </template>
        </el-table-column>
        <el-table-column
          label="任务编号"
          align="left"
          prop="rwbh"
          min-width="150px"
          :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
            <el-tag
              size="small"
              :class="
                scope.row.statusString == '任务结束'
                  ? 'grey'
                  : scope.row.statusString == '任务终止'
                  ? 'red'
                  : 'grey'
              "
              >{{ scope.row.rwbh }}</el-tag
            >
          </template>
        </el-table-column>
        <el-table-column
          label="任务标题"
          align="left"
          prop="title"
          min-width="150px"
          :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
            <el-tag
              size="small"
              :class="
                scope.row.statusString == '任务结束'
                  ? 'grey2'
                  : scope.row.statusString == '任务终止'
                  ? 'red'
                  : 'grey'
              "
              >{{ scope.row.title }}</el-tag
            >
          </template>
        </el-table-column>
        <el-table-column
          label="任务所属部门"
          align="left"
          prop="bmmc"
          min-width="150px"
          :show-overflow-tooltip="true"
        />
        <el-table-column
          label="任务所属条线"
          align="left"
          prop="txlxString"
          min-width="150px"
          :show-overflow-tooltip="true"
        />
        <el-table-column
          label="任务类型"
          align="left"
          prop="name"
          min-width="150px"
          :show-overflow-tooltip="true"
        />
        <el-table-column
          label="子类"
          align="left"
          prop="sun"
          min-width="150px"
          :show-overflow-tooltip="true"
        />
        <el-table-column
          label="任务状态"
          align="left"
          prop="statusString"
          min-width="150px"
          :show-overflow-tooltip="true"
        />
        <el-table-column
          label="认领概况"
          align="left"
          prop="rlgk"
          min-width="150px"
          :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
            <el-button type="text" @click="toDetail(scope.row)">{{
              scope.row.rlgk
            }}</el-button>
          </template>
        </el-table-column>
        <el-table-column
          label="申请人"
          align="left"
          prop="sqName"
          min-width="150px"
          :show-overflow-tooltip="true"
        />
        <el-table-column
          label="计划总工时（人日）"
          align="left"
          prop="gs"
          min-width="150px"
          :show-overflow-tooltip="true"
        />
        <el-table-column
          label="实际总工时（人日）"
          align="left"
          prop="sjgzl"
          min-width="150px"
          :show-overflow-tooltip="true"
        />
        <el-table-column
          label="协作开始时间"
          align="left"
          prop="qsrq"
          min-width="150px"
          :show-overflow-tooltip="true"
        />
        <el-table-column
          label="协作结束时间"
          align="left"
          prop="jsrq"
          min-width="150px"
          :show-overflow-tooltip="true"
        />
        <el-table-column
          label="任务申请时间"
          align="left"
          prop="createTime"
          min-width="150px"
          :show-overflow-tooltip="true"
        />
        <template slot="empty">
          <div class="nodata">
            <img src="@/img/nodata.png" alt="" width="160" />
            <div>暂无数据</div>
          </div>
        </template>
      </el-table>
      <pagination
        v-show="task.taskList.list.count > 0"
        :total="task.taskList.list.count"
        :page.sync="listQuery.page"
        :limit.sync="listQuery.pageSize"
        @pagination="getList"
      />
    </div>
    <!-- 认领概况 -->
    <el-dialog
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      title="认领概况"
      :visible.sync="dialogFlag1"
      width="90%"
      v-if="dialogFlag1"
      id="mx-dialog"
    >
      <rlmx :mxParams="mxParams"></rlmx>
    </el-dialog>
    <!-- 任务终止 -->
    <el-dialog
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      title="任务终止"
      :visible.sync="dialogFlag2"
      width="90%"
    >
      <el-form ref="rules" :model="rwzzForm" label-width="100px" id="save-form">
        <el-input
          type="textarea"
          placeholder="请输入终止理由"
          :rows="8"
          maxlength="500"
          show-word-limit
          v-model="rwzzForm.zzly"
        ></el-input>
        <div class="row">
          <div class="title">任务信息</div>
          <div class="card apply-info">
            <div class="item">
              <div>任务编号：</div>
              <div>{{ rwzzForm.rwbh }}</div>
            </div>
          </div>
          <div class="card apply-info">
            <div class="item">
              <div>任务标题：</div>
              <div>{{ rwzzForm.title }}</div>
            </div>
          </div>
        </div>
      </el-form>
      <div slot="footer">
        <el-button
          type="primary"
          size="small"
          @click="saveZzly()"
          style="margin-right: 15px"
          >确 定</el-button
        >
        <el-button size="small" @click="dialogFlag2 = false">取消</el-button>
      </div>
    </el-dialog>

    <el-dialog
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      title="任务查看"
      :visible.sync="taskViewDialog"
      width="90%"
      v-if="taskViewDialog"
      id="mx-dialog"
    >
      <TaskView :mxParams="mxParams" @giveFather="getSon"></TaskView>
    </el-dialog>
    <el-dialog
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      title="新增任务"
      :visible.sync="taskAddDialog"
      width="90%"
      v-if="taskAddDialog"
      id="mx-dialog"
    >
      <TaskAdd ref="addTask" @giveFather="getSon"></TaskAdd>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="addTask(0)">保存</el-button>
        <el-button type="primary" @click="addTask(1)">提交</el-button>
        <el-button type="primary" @click="resetAdd">重置</el-button>
        <el-button @click="taskAddDialog = false">关闭</el-button>
      </div>
    </el-dialog>

    <el-dialog
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      title="编辑任务"
      :visible.sync="taskEditDialog"
      width="90%"
      v-if="taskEditDialog"
      id="mx-dialog"
    >
      <TaskEdit
        ref="editTask"
        :mxParams="mxParams"
        @giveFather="getSon"
      ></TaskEdit>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="editTask()" v-if="row.status != 2"
          >提交</el-button
        >
        <el-button type="primary" @click="editTask()" v-else
          >重新提交审核</el-button
        >
        <el-button type="primary" @click="resetEdit" v-if="row.status == 1"
          >重置</el-button
        >
        <el-button @click="taskEditDialog = false">关闭</el-button>
      </div>
    </el-dialog>
    <el-dialog
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      title="任务审核"
      :visible.sync="taskApplyAuditDialog"
      width="90%"
      v-if="taskApplyAuditDialog"
      id="applyAudit-dialog"
    >
      <TaskApplyAudit
        :mxParams="mxParams"
        @giveFather="getSon"
      ></TaskApplyAudit>
    </el-dialog>
    <el-dialog
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      title="任务认领"
      :visible.sync="taskClaimDialog"
      width="90%"
      v-if="taskClaimDialog"
      id="mx-dialog"
    >
      <!-- <div slot="footer" class="dialog-footer"> -->
      <div style="text-align: right">
        <el-button
          @click="taskClaimDialog = false"
          size="small"
          style="margin-right: 15px"
          >关闭</el-button
        >
        <el-button type="primary" size="small" @click="saveRwrl"
          >认领</el-button
        >
      </div>
      <!-- </div> -->
      <TaskClaim
        @giveFather="getSon"
        :mxParams="mxParams"
        ref="rwrlForm"
      ></TaskClaim>
    </el-dialog>
    <el-dialog
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :title="txlx == '技术条线' ? '任务完成' : '成果物上传'"
      :visible.sync="cgwUploadDialog"
      width="90%"
      top="20px"
      v-if="cgwUploadDialog"
      :show-close="false"
    >
      <CgwUpload
        v-if="cgwUploadDialog"
        ref="uploadForm"
        :mxParams="mxParams"
        @hideDialog="closeCgwUploadDialog"
      ></CgwUpload>
    </el-dialog>
    <el-dialog
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      title="认领审核设置"
      :visible.sync="taskClaimSettingDialog"
      width="90%"
      v-if="taskClaimSettingDialog"
      id="mx-dialog"
    >
      <TaskClaimSetting
        :mxParams="mxParams"
        ref="taskClaimSettingForm"
        @giveFather="getSon"
      ></TaskClaimSetting>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="saveRlshrtz">保存</el-button>
        <el-button @click="taskClaimSettingDialog = false">关闭</el-button>
      </div>
    </el-dialog>
    <el-dialog
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      title="认领审核"
      :visible.sync="taskClaimAuditDialog"
      width="90%"
      v-if="taskClaimAuditDialog"
      id="mx-dialog"
    >
      <TaskClaimAudit
        :mxParams="mxParams"
        ref="taskClaimAuditForm"
        @giveFather="getSon"
      ></TaskClaimAudit>
      <div slot="footer" class="dialog-footer">
        <div v-if="task.rwshBtnPermission" style="display: inline-block">
          <el-button type="primary" @click="saveRlsh(1)">通过</el-button>
          <el-button type="danger " @click="saveRlsh(0)">驳回</el-button>
        </div>
        <el-button @click="taskClaimAuditDialog = false">关闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Pagination from "@/components/Pagination";
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import { formatMomentDate } from "@/utils/utils";
import {
  getTaskList,
  taskExport,
  rwzzUpdate,
  getDictData,
} from "@/api/task.js";
import {
  getBmxxList,
  getTasklxList,
  getTaskZlList,
  getKeyValue,
} from "@/api/taskType.js";
import CgwUpload from "../cgw/cgwUpload";
import rlmx from "./rlmx.vue";
import TaskView from "./taskView.vue";
import TaskAdd from "./taskAdd.vue";
import TaskEdit from "./taskEdit.vue";
import TaskApplyAudit from "./taskApplyAudit.vue";
import TaskClaim from "./taskClaim/taskClaim.vue";
import TaskClaimSetting from "./taskClaim/taskClaimSetting.vue";
import TaskClaimAudit from "./taskClaim/taskClaimAudit.vue";
export default {
  // 列表分页
  components: {
    Pagination,
    rlmx,
    TaskView,
    TaskAdd,
    TaskEdit,
    TaskClaim,
    CgwUpload,
    TaskApplyAudit,
    TaskClaimSetting,
    Treeselect,
    TaskClaimAudit,
  },

  data() {
    return {
      normalizer(node) {
        return {
          children: node.users,
        };
      },
      type: "0",
      height: 100,
      listQuery: {
        type: "0",
        sun: "",
        name: "",
        bmbh: "",
        txlx: "",
        status: "",
        rlr: null,
        title: "",
        rlrq: "",
        page: 1,
        pageSize: 10,
      },
      row: {},
      listLoading: true,
      total: 0,
      value: "",
      time: [],
      list: [],
      ygtxoptions: [],
      bmList: [],
      lxList: [],
      zlList: [],
      statusList: [],
      rwzzForm: {
        id: "",
        zzly: "",
        rwbh: "",
        title: 0,
      },
      show: true,
      dialogFlag1: false,
      dialogFlag2: false,
      cgwUploadDialog: false,
      taskViewDialog: false,
      taskAddDialog: false,
      taskEditDialog: false,
      taskApplyAuditDialog: false,
      taskClaimDialog: false,
      taskClaimSettingDialog: false,
      taskClaimAuditDialog: false,
      rwshBtnPermission: true,
      txlx: "",
    };
  },
  computed: {
    ...mapGetters(["deptUser", "user", "task"]),
  },
  created() {
    if (!this.deptUser || this.deptUser.length == 0) {
      this.$store.dispatch("common/getDeptUser");
    }
    this.$store.dispatch("common/fetchUserInfoAction");
    this.listQuery = { ...this.task.taskList.params };
    getBmxxList("0").then((res) => {
      if (res.code == 0) {
        this.bmList = res.data;
      }
    });

    getTasklxList().then((res) => {
      if (res.code == 0) {
        this.lxList = res.data;
      }
    });
    getTaskZlList().then((res) => {
      if (res.code == 0) {
        this.zlList = res.data;
      }
    });

    getKeyValue("TXLX", "", "0").then((res) => {
      if (res.code === 0) {
        this.ygtxoptions = res.data;
      }
    });

    getDictData("rwxz_task_status", 1).then((res) => {
      if (res.code === 0) {
        this.statusList = res.data;
      }
    });
    this.getList();
  },
  methods: {
    changeShow() {
      this.show = !this.show;
      // this.listQuery.bmbh = this.user.bmbh;
      // this.listQuery.txlx = this.user.tx;
    },
    handleClick(tab, event) {
      this.getList();
    },
    handleView(id, txlx) {
      this.mxParams = {
        id: id,
        txlx,
      };
      this.taskViewDialog = true;
    },
    handleAdd() {
      this.taskAddDialog = true;
    },
    handleEdit(row) {
      this.row = row;
      this.mxParams = {
        id: row.id,
      };
      this.taskEditDialog = true;
    },
    handleRwAppylAudit(id) {
      this.mxParams = {
        id: id,
      };
      this.taskApplyAuditDialog = true;
    },
    handleRwrl(id) {
      this.mxParams = {
        id: id,
      };
      this.taskClaimDialog = true;
    },
    handleUpload(id, txlx, rwbh, title) {
      this.mxParams = {
        id,
        txlx,
        rwbh,
        title,
      };
      this.txlx = txlx;
      this.cgwUploadDialog = true;
    },
    closeCgwUploadDialog(list) {
      if (list) {
        for (let index = 0; index < list.length; index++) {
          const file = list[index];
          this.$store.dispatch("cgw/fetchDeleteFileAction", {
            fileId: file.fileid,
            path: file.url,
          });
        }
      }
      this.cgwUploadDialog = false;
    },
    handleRlshsz(id) {
      this.mxParams = {
        id: id,
      };
      this.taskClaimSettingDialog = true;
    },
    handleRlsh(id) {
      this.mxParams = {
        id,
      };
      this.taskClaimAuditDialog = true;
    },
    getList() {
      let rlrq = null;
      if (this.listQuery.rlrq) {
        rlrq = formatMomentDate(new Date(this.listQuery.rlrq));
      }
      let rlr = null;
      rlr = this.listQuery.rlr ? this.listQuery.rlr.join(",") : null;
      const params = { ...this.listQuery, rlrq, rlr };
      this.$store.dispatch("task/fetchTaskListAction", params).then((res) => {
        if (res.code == 0) {
          const docH = document.documentElement.clientHeight;
          const mycontainerH =
            document.querySelector(".mycontainer").clientHeight;
          this.height = docH - mycontainerH - 115;
        }
      });
      // getTaskList(params).then((res) => {
      //   if (res.code == 0) {
      //     this.list = res.data;
      //     this.total = res.count;
      //     this.listLoading = false;
      //     const docH = document.documentElement.clientHeight;
      //     const mycontainerH =
      //       document.querySelector(".mycontainer").clientHeight;
      //     this.height = docH - mycontainerH - 50;
      //   }
      // });
    },
    handleChangeLx() {
      getTasklxList(this.listQuery.bmbh, this.listQuery.txlx).then((res) => {
        if (res.code == 0) {
          this.lxList = res.data;
        }
      });
    },

    handleChangeTx(i) {
      this.listQuery.bmbh = i;
      this.listQuery.bmmc = i;
      getKeyValue("TXLX", i, "1").then((res) => {
        if (res.code === 0) {
          this.ygtxoptions = res.data;
        }
      });
    },

    handleChangeZl() {
      getTaskZlList(
        this.listQuery.name,
        this.listQuery.bmbh,
        this.listQuery.txlx
      ).then((res) => {
        if (res.code == 0) {
          this.zlList = res.data;
        }
      });
    },

    toDetail(row) {
      this.mxParams = {
        id: row.id,
      };
      this.dialogFlag1 = true;
    },
    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 0) {
        return "background-color: #f2f2f2;";
      }
    },
    toCgwList(taskId) {
      this.$router.push({
        name: "cgwList",
        params: {
          taskId: taskId,
        },
      });
    },
    reward(taskId) {
      this.$router.push({
        name: "reward",
        params: {
          taskId: taskId,
        },
      });
    },
    //任务终止
    rwzzUpdate(row) {
      this.dialogFlag2 = true;
      this.rwzzForm.id = row.id;
      this.rwzzForm.rwbh = row.rwbh;
      this.rwzzForm.title = row.title;
      this.rwzzForm.zzly = "";
    },
    saveZzly() {
      const params = {
        id: this.rwzzForm.id,
        zzly: this.rwzzForm.zzly,
      };
      rwzzUpdate(params).then((res) => {
        if (res.code == 0) {
          this.dialogFlag2 = false;
          this.$message.success(res.msg);
          this.getList();
        } else {
          this.$message.error(res.msg);
        }
      });
    },

    //导出
    handleExport() {
      let rlrq = null;
      if (this.listQuery.rlrq) {
        rlrq = formatMomentDate(new Date(this.listQuery.rlrq));
      }
      let rlr = null;
      rlr = this.listQuery.rlr ? this.listQuery.rlr.join(",") : null;
      const params = { ...this.listQuery, rlrq, rlr };
      taskExport(params).then((res) => {
        if (res.code === 0) {
          const fileName = res.msg.substr(
            res.msg.indexOf("_") + 1,
            res.msg.length
          );
          const filePath = res.msg;
          const url =
            window.g.apiUrl +
            "system/downloadFile?fileName=" +
            fileName +
            "&filePath=" +
            filePath;
          // 组装a标签
          const elink = document.createElement("a");
          // 设置下载文件名
          elink.download = fileName;
          elink.style.display = "none";
          elink.href = url;
          document.body.appendChild(elink);
          elink.click();
          document.body.removeChild(elink);
        } else {
          this.$message({
            showClose: true,
            message: res.msg,
            type: "error",
          });
        }
      });
    },
    //任务认领保存
    saveRwrl() {
      this.$refs.rwrlForm.saveRwrl();
    },

    saveRlshrtz() {
      this.$refs.taskClaimSettingForm.saveForm();
    },

    // 认领审核
    saveRlsh(status) {
      this.$refs.taskClaimAuditForm.saveForm(status);
      // this.taskClaimAuditDialog = false;
    },
    addTask(status) {
      this.$refs.addTask.submitUpload(status);
    },
    editTask() {
      this.$refs.editTask.submitUpload();
    },
    resetAdd() {
      this.$refs.addTask.resetFrom();
    },
    resetEdit() {
      this.$refs.editTask.resetFrom();
    },
    getSon(temp) {
      this.dialogFlag1 = false;
      this.dialogFlag2 = false;
      this.cgwUploadDialog = false;
      this.taskViewDialog = false;
      this.taskApplyAuditDialog = false;
      this.taskClaimSettingDialog = false;
      this.taskClaimAuditDialog = false;
      this.taskAddDialog = temp;
      this.taskEditDialog = temp;
      this.taskClaimDialog = temp;
    },
    // 重置
    reset() {
      this.listQuery = {
        ...this.listQuery,
        ...{
          bmbh: null,
          txlx: null,
          name: null,
          sun: null,
          status: null,
          ygbh: null,
          title: null,
          rlr: null,
        },
      };
    },
  },
};
</script>
<style lang="less" scoped>
.flex-button {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 5%;
}
.choice-box {
  border: 1px solid;
  border-color: #cccc;
  display: auto;
}
.app-container {
  padding: 10px;
  .dialog-footer {
    text-align: right;
    button {
      margin-left: 30px;
    }
  }
}
.red {
  color: #ff0000 !important;
  border-color: #fff !important;
  background-color: #fff;
}
.grey {
  color: #606266 !important;
  border-color: #fff !important;
  background-color: #fff;
}
.grey2 {
  color: #999 !important;
  border-color: #fff !important;
  background-color: #fff;
}
.mycontainer {
  padding: 10px;
  background-color: #fff;
  border-radius: 6px;
}
.mycontainer .el-form-item {
  margin-bottom: 5px;
}
.filter-container {
  background-color: #fff;
  padding: 0;
}
.filter-container .filter-item {
  margin-bottom: 0;
}
.search-container {
  border: 0;
}
.btn-container {
  padding-top: 0px;
  margin-top: 10px;
  background-color: #f2f2f2;
  border-top: #e2e2e2 1px solid;
  border-left: #e2e2e2 1px solid;
  border-right: #e2e2e2 1px solid;
}

.dialog-header {
  background-color: #f2f2f2;
  margin: 5px 5px;
}
.btn {
  display: block;
  margin: 10px 10px;
  width: 120px;
  height: 40px;
  font-size: 14px;
  line-height: 40px;
  text-align: center;
  background-color: rgba(0, 0, 0, 0.08);
  cursor: pointer;
}
.avatar {
  display: block;
  width: 60px;
  margin: 10px 10px;
}
.el-button + .el-button {
  margin-left: 0px;
}
.el-input__inner {
  width: 100%;
}

.flex-container {
  display: -webkit-flex;
  display: flex;
  -webkit-align-items: center;
  align-items: center;
  -webkit-justify-content: center;
  justify-content: center;
  width: 100%;
  height: 100%;
}
.flex-item1 {
  width: 40%;
  margin: 1%;
  min-height: 203.69px;
}
.flex-item2 {
  width: 80px;
  height: 70px;
}
.flex-item3 {
  width: 40%;
  margin: 1%;
  min-height: 203.69px;
}
.el-table__row > td {
  border: none;
}
.el-table::before {
  height: 0px;
}
.el-table th.is-leaf,
.el-table td {
  border-bottom: 0px;
}

::v-deep .el-dialog {
  width: 64%;
}
::v-deep .el-transfer-panel {
  width: 263px;
}
.pagination-container {
  border: none;
}
::v-deep #save-form .el-form-item__label {
  width: 150px !important;
}
::v-deep #save-form .el-form-item__content {
  margin-left: 150px !important;
}
::v-deep #save-form .el-select {
  width: 100% !important;
}

#save-form .el-form-item {
  margin-bottom: 20px;
}
.row {
  margin-top: 15px;
  .title {
    height: 44px;
    background-color: #d7d7d7;
    padding-left: 15px;
    font-size: 16px;
    line-height: 44px;
    margin-bottom: 15px;
  }
  .step-wrap {
    padding: 0 10%;
  }
  .apply-info {
    display: flex;
    height: 44px;
    line-height: 44px;
    .item {
      padding: 0 50px;
    }
    div {
      display: flex;
    }
  }
}
.myRadio {
  margin-right: 5px;
}
.gray {
  background-color: #ddd;
  border-color: #ddd;
}
</style>
